import React from "react";

function Divisor(props: any) {
  return <div className="divisor" style={props.style} />
}

export { Divisor }